import React from 'react';
import {
  FieldLabel,
  Red,
  Row,
  RowWrapper,
  Section,
  SectionTitle,
  UserFormProps,
  getInputField,
} from '../../../components/AdminFormComponents';
import {
  EmailAndUsernameInput,
  USERNAME,
} from 'app/pages/admin/components/EmailAndUsernameInput';
import { checkUsername } from 'lib/api';
import { NAPLETON_AUTOMOTIVE_RESELLER_ID } from 'lib/const/SuperAdminConstants';
import { RESELLER_IDS } from 'lib/const';
import { useTranslation } from 'react-i18next';

export const PersonalInfoSection = (props: UserFormProps) => {
  const { t } = useTranslation();
  const { isSubmitting, isNewUser, setFieldValue, values } = props;
  const [usernameValid, setUsernameValid] = React.useState(true);

  const checkExistingUser = async (value: string) => {
    const trimmedUserName = value.trim();
    const userValid = await checkUsername(trimmedUserName, '');
    const usernameValid = !!trimmedUserName && !userValid.userExist;
    setUsernameValid(usernameValid);
  };
  const isCurrentCDKReseller =
    props.values.resellerId?.toString() === RESELLER_IDS.CDK;

  return (
    <Section id={'personalInfo'}>
      <SectionTitle>Personal info</SectionTitle>
      <RowWrapper>
        <Row>
          <FieldLabel>First Name {isNewUser && <Red>*</Red>}</FieldLabel>
          {getInputField(
            'firstName',
            true,
            false,
            isSubmitting,
            'text',
            isCurrentCDKReseller
          )}
        </Row>
        <Row>
          <FieldLabel>
            Last Name{' '}
            {props.values.resellerId !== NAPLETON_AUTOMOTIVE_RESELLER_ID && (
              <Red>*</Red>
            )}
          </FieldLabel>
          {getInputField(
            'lastName',
            true,
            false,
            isSubmitting,
            'text',
            isCurrentCDKReseller
          )}
        </Row>
        {isNewUser && (
          <Row>
            <FieldLabel>Email {isNewUser && <Red>*</Red>}</FieldLabel>
            <EmailAndUsernameInput
              name='email'
              required={true}
              readOnly={false}
              isSubmitting={isSubmitting}
              onChange={() => {
                setFieldValue(USERNAME, values.email);
                checkExistingUser(values.email);
              }}
            />
          </Row>
        )}
        {isNewUser && (
          <Row>
            <FieldLabel>{t('Reply To')}</FieldLabel>
            <EmailAndUsernameInput
              name='email2'
              required={false}
              readOnly={false}
              isSubmitting={isSubmitting}
            />
          </Row>
        )}
        <Row>
          <FieldLabel>
            Username <Red>*</Red>
          </FieldLabel>
          <EmailAndUsernameInput
            name={USERNAME}
            required={true}
            readOnly={false}
            isSubmitting={isSubmitting}
            value={values.username}
            onChange={() => {
              checkExistingUser(values.username.trim());
            }}
            disabled={isCurrentCDKReseller}
            isUsernameValid={usernameValid}
          />
        </Row>
      </RowWrapper>
    </Section>
  );
};
